import { resolveApptTypeParam } from '@src/utils/appointmentTypesUtils';

export const WORKPLACE_SCREENING_TAG = 'Workplace screening or exam';

export interface VisitReasonValidationState {
	hasSelectedVisitReason: boolean;
	requiresFollowUpQuestion: boolean;
	hasSelectedWorkplaceScreeningOption: boolean;
	isValid: boolean;
	errorMessage: string | null;
}

export function getVisitReasonValidation(selectedTag: string, selectedPhysicalTag: string): VisitReasonValidationState {
	const hasSelectedVisitReason = Boolean(selectedTag);
	const requiresFollowUpQuestion = selectedTag === WORKPLACE_SCREENING_TAG;
	const hasSelectedWorkplaceScreeningOption = Boolean(selectedPhysicalTag);
	const isValid = hasSelectedVisitReason && (!requiresFollowUpQuestion || hasSelectedWorkplaceScreeningOption);
	const errorMessage = !hasSelectedVisitReason
		? 'Please select a visit reason to continue'
		: requiresFollowUpQuestion && !hasSelectedWorkplaceScreeningOption
		? 'Please answer the follow-up question to continue'
		: null;

	return {
		hasSelectedVisitReason,
		requiresFollowUpQuestion,
		hasSelectedWorkplaceScreeningOption,
		isValid,
		errorMessage,
	};
}

/**
 * The `appt-type` to carry to /results for the selected visit reason.
 *
 * Workplace sends the physicals answer (OM-COMPLEX / OM-STANDARD) rather than the display tag:
 * the display tag maps to OM-COMPLEX for everyone, which silently turns a "No" into a "Yes".
 *
 * The result is resolved to its canonical appointment type so this page and the reason filter on
 * /results emit the identical param — otherwise the same reason reaches /results as both
 * "School or sport physical" and "School / Sport Physical", and the two URLs are not interchangeable
 * to anyone reading or sharing them.
 */
export function getApptTypeParam(selectedTag: string, selectedPhysicalTag: string): string {
	const reason = selectedTag === WORKPLACE_SCREENING_TAG ? selectedPhysicalTag : selectedTag;

	// An unresolvable reason is passed through untouched so /results can reject it as it always has
	return resolveApptTypeParam(reason) ?? reason;
}
